import './styles.less';

import { observer } from 'mobx-react';
import React from 'react';

import { useStore } from 'core/react/useStore';

import { Toolbar } from 'controls/react/layout/toolbar';
import { Section } from 'controls/react/layout/section';
import { Grid } from 'controls/grid/grid';
import { i18n } from 'core/localization';
import { GridSearchInput } from 'controls/grid/gridSearchInput';
import { AntButton } from 'controls/react/ant/antButton';

import { DataSourceDataConstructorStore } from './store';
import { DataSourceDataConstructorProps } from './types';
import { AntAlert } from 'controls/react/ant/antAlert';

const b = require('b_').with('data-source-data-constructor');

export const DataSourceDataConstructor = observer((props: DataSourceDataConstructorProps) => {
	const store = useStore(() => new DataSourceDataConstructorStore(props));

	const infoMessage = <span dangerouslySetInnerHTML={{ __html: store.infoMessage }}></span>;
	const helpMessage = <span dangerouslySetInnerHTML={{ __html: store.helpMessage }}></span>;

	const gridStore = store.dataSourceDataGridStore?.gridStore;

	return (
		<Section contentPadding={false}>
			<Toolbar title={store.title}>
				<GridSearchInput store={gridStore} />
				{store.step != 'categorySelection' && (
					<AntButton type={'primary'} onClick={store.onBackClick}>
						{i18n('Back')}
					</AntButton>
				)}
				<AntButton type={'primary'} onClick={store.onNextClick} disabled={!store.nextEnabled}>
					{store.step == 'columnsSelection' ? i18n('Complete') : i18n('Next')}
				</AntButton>
			</Toolbar>
			<Section appearance={'none'} direction={'row'} height={'full'}>
				<Section className={b('grid')} appearance={'none'}>
					<Section>
						<AntAlert type={'info'} message={infoMessage} />
					</Section>
					<Grid store={store.dataSourceDataGridStore?.gridStore} />
				</Section>
				<Section className={b('help-section')}>
					<div className={b('help-header')}>{store.helpHeader}</div>
					<div>{helpMessage}</div>
					<div className={b('help-image')}>
						<img
							src={'assets-static/dashboard-designer/data-source-widget-' + store.step + '.png'}
							alt={'step preview'}
						/>
					</div>
				</Section>
			</Section>
		</Section>
	);
});
